import { ColorPalettePreviewSwatchComponent, ColorPaletteSelectorComponent } from '@mode/colors/ui';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@mode/capra';
import { OrgTypes } from '@mode/shared/contract-common';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent, ColorPaletteSelectorComponent, ColorPalettePreviewSwatchComponent],
  selector: 'mode-color-palette-assignment',
  templateUrl: './color-palette-assignment.component.html',
  styleUrls: ['./color-palette-assignment.component.scss'],
})
export class ColorPaletteAssignmentComponent {
  @Input() selectedColorPalette: OrgTypes.ColorPalette | undefined = undefined;
  @Input() allColorPalettes: OrgTypes.ColorPalette[] = [];
  @Output() paletteAssigned = new EventEmitter<OrgTypes.ColorPalette>();

  onAssignPaletteClick() {
    this.paletteAssigned.emit(this.selectedColorPalette);
  }

  onPaletteChanged(palette: OrgTypes.ColorPalette) {
    this.selectedColorPalette = palette;
  }
}
